import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  success(text: string): void {
    this.snackBar.open(text, null, {
      panelClass: ['snackbar', 'snackbar--success']
    });
  }

  info(text: string): void {
    this.snackBar.open(text, null, {
      panelClass: ['snackbar', 'snackbar--info']
    });
  }

  error(error: string): void {
    const duration = 10000;
    this.snackBar.open(error, null, { panelClass: ['snackbar', 'snackbar--error'], duration });
  }
}
